import { Hidden, IconButton, Typography } from '@material-ui/core'
import ShowActionIcon from '@material-ui/icons/Visibility'
import Skeleton from '@material-ui/lab/Skeleton'
import React from 'react'

import useStyles from './styles/RatePlansPoliciesListRow.styles'

const PolicyRowSkeleton: React.FC = () => {
  const classes = useStyles()

  return (
    <>
      <div className={classes.tableRow}>
        <div>
          <Typography variant="body1">
            <Skeleton animation="wave" className={classes.skeleton} />
          </Typography>
        </div>
        <Hidden smDown>
          <div>
            <Typography variant="body1">
              <Skeleton animation="wave" className={classes.skeleton} />
            </Typography>
          </div>
          <div>
            <Typography variant="body1">
              <Skeleton animation="wave" className={classes.skeleton} />
            </Typography>
          </div>
        </Hidden>
        <div>
          <IconButton onClick={() => {}}>
            <ShowActionIcon />
          </IconButton>{' '}
        </div>
        <div />
      </div>
    </>
  )
}

export default PolicyRowSkeleton
